

export const FETCH_DATA2_REQUEST = 'FETCH_DATA2_REQUEST';
export const FETCH_DATA2_SUCCESS = 'FETCH_DATA2_SUCCESS';
export const FETCH_DATA2_FAILURE = 'FETCH_DATA2_FAILURE';

// Action types
export const SAVE_DATA_REQUEST = "SAVE_DATA_REQUEST";
export const SAVE_DATA_SUCCESS = "SAVE_DATA_SUCCESS";
export const SAVE_DATA_FAILURE = "SAVE_DATA_FAILURE";